var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.$_hasRole('sysAdmin'))?_c('SysAdmins'):(_vm.$_hasRole('schoolAdmin'))?_c('SchoolAdmins'):_c('div',[_c('v-alert',{attrs:{"type":"error","prominent":"","border":"left"}},[_vm._v("Sie haben keine Berechtigung, diese Seite zu sehen.")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }